export const canAccessStorefront = (isCACRegistered, businessTier) =>
  (isCACRegistered && businessTier > 1) ||
  (!isCACRegistered && ( businessTier === 3));
